/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_subjects_order_cancellation = /** @type {(inputs: {}) => string} */ () => {
	return `Chci zrušit / vrátit svou objednávku.`
};

const da_contact_subjects_order_cancellation = /** @type {(inputs: {}) => string} */ () => {
	return `Jeg vil annullere/returnere min ordre.`
};

const de_contact_subjects_order_cancellation = /** @type {(inputs: {}) => string} */ () => {
	return `Ich möchte meine Bestellung stornieren/zurückgeben.`
};

const en_contact_subjects_order_cancellation = /** @type {(inputs: {}) => string} */ () => {
	return `I want to cancel/return my order.`
};

const es_contact_subjects_order_cancellation = /** @type {(inputs: {}) => string} */ () => {
	return `Quiero cancelar / devolver mi pedido.`
};

const fr_contact_subjects_order_cancellation = /** @type {(inputs: {}) => string} */ () => {
	return `Je souhaite annuler / retourner ma commande.`
};

const hu_contact_subjects_order_cancellation = /** @type {(inputs: {}) => string} */ () => {
	return `Szeretném lemondani / visszaküldeni a rendelésem.`
};

const it_contact_subjects_order_cancellation = /** @type {(inputs: {}) => string} */ () => {
	return `Voglio annullare/restituire il mio ordine.`
};

const nl_contact_subjects_order_cancellation = /** @type {(inputs: {}) => string} */ () => {
	return `Ik wil mijn bestelling annuleren/retourneren.`
};

const pl_contact_subjects_order_cancellation = /** @type {(inputs: {}) => string} */ () => {
	return `Chcę anulować/zwrocić zamówienie.`
};

const pt_contact_subjects_order_cancellation = /** @type {(inputs: {}) => string} */ () => {
	return `Quero cancelar / devolver meu pedido.`
};

const sv_contact_subjects_order_cancellation = /** @type {(inputs: {}) => string} */ () => {
	return `Jag vill avbryta/returnera min beställning.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_subjects_order_cancellation = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_subjects_order_cancellation(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_subjects_order_cancellation", locale)
	if (locale === "cs") return cs_contact_subjects_order_cancellation(inputs)
	if (locale === "da") return da_contact_subjects_order_cancellation(inputs)
	if (locale === "de") return de_contact_subjects_order_cancellation(inputs)
	if (locale === "en") return en_contact_subjects_order_cancellation(inputs)
	if (locale === "es") return es_contact_subjects_order_cancellation(inputs)
	if (locale === "fr") return fr_contact_subjects_order_cancellation(inputs)
	if (locale === "hu") return hu_contact_subjects_order_cancellation(inputs)
	if (locale === "it") return it_contact_subjects_order_cancellation(inputs)
	if (locale === "nl") return nl_contact_subjects_order_cancellation(inputs)
	if (locale === "pl") return pl_contact_subjects_order_cancellation(inputs)
	if (locale === "pt") return pt_contact_subjects_order_cancellation(inputs)
	return sv_contact_subjects_order_cancellation(inputs)
};
export { contact_subjects_order_cancellation as "contact.subjects.order_cancellation" }